import * as React from 'react';
import { Button } from '../../../../commonv3/components/atoms/buttons/Button';
import './subscriptionSuspensionCancelCompletePane.module.scss';
import { ReservationPane } from '../../atoms/reservations/ReservationPane';
import moment from 'moment-timezone';
import { ISODate } from '../../../../commonv3/types/dates';

type Props = {
    onCompleteClick: () => any;
    renewalDate: ISODate;
    durationMonth: number;
};

export class SubscriptionSuspensionCancelCompletePane extends React.Component<Props> {
    render() {
        const { onCompleteClick, renewalDate, durationMonth } = this.props;
        return (
            <ReservationPane styleName="pane">
                <div styleName="schedule_text">復帰が完了しました</div>
                <div styleName="text">
                    復帰おめでとうございます！これからまたSHElikesでの学習を頑張っていきましょう！
                </div>
                <div styleName="schedule_box_inner">
                    <div styleName="schedule_text">新しい課金日について</div>
                    <div styleName="text">
                        課金日が毎月{moment(renewalDate).format('D')}日に設定されました。
                        {moment(renewalDate).format('YYYY/MM/DD')}〜
                        {moment(renewalDate)
                            .add(durationMonth, 'M')
                            .format('YYYY/MM/DD')}分の受講料に対する課金が本日発生いたします。
                    </div>
                </div>
                <Button styleName="button" type="primary" size="m" disabled={false} onClick={onCompleteClick}>
                    マイページへ戻る
                </Button>
            </ReservationPane>
        );
    }
}
